import Chapter from '../Chapter/Chapter'
import { Loading } from '../common'
import { DebugExitZone } from '../debug'
import useUserProfile from './useUserProfile.hook'
import styles from './UserProfile.module.scss'
import { CopyContainer } from '../common/copy'
import { ItemThumbs } from '../item'
import { DossierTypeEnum } from '../../shared/types'

const UserProfile = () => {
  const { profile, dossier, zone, coords, error, loading, debug, debugP2 } =
    useUserProfile()
  console.log('dossier', dossier)

  return (
    <Loading loading={loading} message="Loading UserProfile...">
      <div className={styles.userProfileRoot}>
        <CopyContainer
          padding={{ top: 'medium', left: 'large', bottom: 'large' }}
        >
          <Chapter />
          <h3>
            You are in zone: <span style={{ color: 'red' }}>{zone?.name}</span>
          </h3>

          {dossier?.type === DossierTypeEnum.Case && (
            <div>
              ITEMS
              {/* <ItemThumbs items={scene?.items} /> */}
            </div>
          )}

          {debugP2 && (
            <div>
              Active Zone/Dossier Id: {zone?.name}
              <hr />
              {coords && (
                <div>
                  User coords: {coords?.lat}, {coords?.long}
                </div>
              )}
              <h3>Zone</h3>
              <pre>{JSON.stringify(zone, null, 2)}</pre>
              <hr />
              <h3>Profile</h3>
              <pre>{JSON.stringify(profile, null, 2)}</pre>
              <hr />
              <h3>Dossier</h3>
              <pre>{JSON.stringify(dossier, null, 2)}</pre>
            </div>
          )}
        </CopyContainer>

        {/* <br />
        <div className="white-block" /> */}

        {/* <DebugExitZone mode={debug ? 'debug' : 'default'} /> */}
        <DebugExitZone mode={'debug'} />
      </div>
    </Loading>
  )
}
export default UserProfile
